





































































import { Component, Vue, Emit } from 'vue-property-decorator';
import { Select } from 'ant-design-vue';

interface TabsObj {
  id: number;
  code: string;
  name: string;
  status: number;
  orderIndex: number;
}
interface StringObj{
  [key: string]: string;
}

@Component({})
export default class IndexFilter extends Vue {
  // 科目
  private subjectList: TabsObj[] = []

  // 学科
  private subjectProData: any = []

  // 筛选条件
  private condition: any = {}

  // 筛选条件排序列表
  private conditionList: any = []

  private selected: any = {
    subjectId: 0, // 科目
    subjectProId: 0, // 学科
    gradeId: 0, // 年级
    period: 0, // 学期
    schemeId: 0, // 体系
    bookVersionId: 0, // 教材版本
    examId: 0, // 考区
    courseCategories: 0, // 班级类别
  }

  private showMore: boolean = false; // 是否显示更多

  private optionIndex: number = 6; // 控制展示列表

  private allCoursesFilterFlag: boolean = false // 第一次刷新时候使用本地默认存储的赛选项

  // 高级筛选
  private handleShowMore() {
    this.$utils.sendAction('index', 'index', 'id-11');
    this.showMore = !this.showMore;
    this.optionIndex = this.showMore ? this.conditionList.length : 6;
  }

  @Emit('callback')
  private updateSelect(selected: StringObj) {
    return selected;
  }

  // 其他筛选条件处理
  private handleFilter(type: string, conditionId: number) {
    const typeMap: StringObj = {
      subjectPro: 'subjectProId',
      subject: 'subjectId',
      grade: 'gradeId',
      period: 'period',
      scheme: 'schemeId',
      bookVersion: 'bookVersionId',
      year: 'year',
      exam: 'examId',
      kindOfClassType: 'courseCategories',
    };
    // 切换科目
    if (type === 'subject' && this.selected.subjectId !== conditionId) {
      this.selected.subjectId = conditionId;
      this.getSubjectPro();
    } else if (type === 'subjectPro' && this.selected.subjectProId !== conditionId) {
      this.selected.subjectProId = conditionId;
      this.getCondition();
    } else {
      const typeId: string = typeMap[type];
      if (this.selected[typeId] !== conditionId) {
        this.selected[typeId] = conditionId;
        if (type === 'grade') {
          // 切换年级时体系、版本、考区选中全部
          this.selected.gradeId = conditionId;
          this.resetDefaultSelect();
        }
        // 调用存储筛选条件
        this.setStoreFilter(this.selected);
        this.updateSelect(this.selected);
      }
    }
  }

  // 根据本地存储的赛选项赋予默认值
  private resetDefaultSelect() {
    // 默认获取筛选项根据本地存储数据为准
    const option = this.$utils.getStore('allCoursesFilter');
    if (option && Object.keys(option).length > 0) {
      this.selected.schemeId = option.schemeId || 0;
      this.selected.bookVersionId = option.bookVersionId || 0;
      this.selected.examId = option.examId || 0;
      this.selected.courseCategories = option.courseCategories || 0;
      this.selected.period = option.period || 0;
    }
  }

  // 根据是否第一次存储，记录点击的赛选操作
  private setStoreFilter(conditionParams: StringObj) {
    // 所有课程筛选条件本地存储
    this.$utils.setStore('allCoursesFilter', conditionParams);
  }

  // 切换时上次保存的记录不一定存在 (体系、教材版本、考区)
  private checkDefault() {
    const schemeList = this.getListByType('scheme');
    const bookVersionList = this.getListByType('bookVersion');
    const examList = this.getListByType('exam');
    const kindOfClassTypeList = this.getListByType('kindOfClassType'); // 1.8.9新增筛选项
    this.checkSelectedId('scheme', schemeList, this.selected.schemeId);
    this.checkSelectedId('bookVersion', bookVersionList, this.selected.bookVersionId);
    this.checkSelectedId('exam', examList, this.selected.examId);
    // 1.8.9新增筛选项
    this.checkSelectedId('kindOfClassType', kindOfClassTypeList, this.selected.courseCategories);
  }

  // 检查默认值是否存在
  private checkSelectedId(type: string, list: any, id: number) {
    const findResult = list.find((item: any) => item.id === id);

    if (!findResult) {
      if (type === 'kindOfClassType') {
        this.selected.courseCategories = 0;
      } else {
        this.selected[`${type}Id`] = 0;
      }
    }
  }

  // 通过类型获取选项的列表
  private getListByType(type: string) {
    const result = this.conditionList.find((item: any) => item.type === type);
    return result.list;
  }

  // 从筛选条件对象转数组
  private filterCondition() {
    const conditionTemp = JSON.parse(JSON.stringify(this.condition));
    const SHOWORDER: string[] = ['subjectData', 'subjectProData', 'gradeData', 'periodData', 'schemeData', 'bookVersionData', 'examData', 'kindOfClassType'];
    this.conditionList = SHOWORDER.map((item) => conditionTemp[item]);
    // 类型调整(长线课、短线课、公开课)顺序
    this.conditionList.forEach((item: any) => {
      if (item && item.type === 'kindOfClassType') {
        [item.list[1], item.list[2]] = [item.list[2], item.list[1]];
      }
    });
  }

  // 第三步获取其他条件
  private async getCondition() {
    const result = await this.$service.bk.getCondition(
      this.selected.subjectId,
      this.selected.subjectProId,
    );
    // 接口返回科目数据只有列表,这里添加其他字段转
    const subjectData = {
      list: this.subjectList,
      name: '科目',
      type: 'subject',
    };
    this.condition = Object.assign(result, { subjectProData: this.subjectProData },
      { subjectData });
    // 后端返回的字段和当初约定的不一致，兼容字段
    result.defaultMap.courseCategories = result.defaultMap.kindClassType;
    // 恢复默认全部选项
    const restoreDefault = {
      schemeId: 0,
      bookVersionId: 0,
      examId: 0,
      courseCategories: 0,
    };
    this.selected = { ...this.selected, ...result.defaultMap, ...restoreDefault };
    this.selected.gradeId = result.gradeData.list[0].id; // 给年级默认值
    // 默认获取筛选项根据本地存储数据为准
    const option = this.$utils.getStore('allCoursesFilter');
    if (!this.allCoursesFilterFlag) {
      if (option && Object.keys(option).length > 0) {
        this.selected = option;
      }
      this.allCoursesFilterFlag = true;
    }
    this.filterCondition();
    // 科目、学科、年级不作记录、其余做记录保存
    this.checkDefault();
    // 调用存储筛选条件
    this.setStoreFilter(this.selected);
    // 上传父组件赛选条件
    this.updateSelect(this.selected);
  }

  // 第二步获取科目
  private async getSubjectPro() {
    const result = await this.$service.bk.getSubjectPro(this.selected.subjectId);
    this.subjectProData = result.subjectProData;
    this.selected.subjectProId = this.subjectProData.list[0].id; // 给学科默认值
    // 默认获取筛选项根据本地存储数据为准
    const option = this.$utils.getStore('allCoursesFilter');
    if (option && Object.keys(option).length > 0 && !this.allCoursesFilterFlag
    && this.subjectProData.list.some((item: any): boolean => item.id === option.subjectProId)) {
      this.selected.subjectProId = option.subjectProId;
    }
    // 获取筛选数据
    this.getCondition();
  }

  // 第一步获取学科
  private async getSubject() {
    const result: any = await this.$service.bk.getSubject();
    if (result.status === 3) {
      window.location.href = 'unauthorized.html';
    }
    this.subjectList = result.data;

    this.selected.subjectId = result.data[0].id; // 给科目默认值
    // 默认获取筛选项根据本地存储数据为准
    const option = this.$utils.getStore('allCoursesFilter');
    if (option && Object.keys(option).length > 0
    && this.subjectList.some((item: any): boolean => item.id === option.subjectId)) {
      this.selected.subjectId = option.subjectId;
    }
    // 获取学科
    this.getSubjectPro();
  }

  // 逻辑从下向上看
  private mounted() {
    // 获取科目
    this.getSubject();
  }
}
